import { faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons/faClockRotateLeft';
import { faMessages } from '@fortawesome/pro-regular-svg-icons/faMessages';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { QTabs, QTab, QBox, QIcon } from '@captivateiq/quotient';


import { ChatTab } from './ChatTab';
import { HistoryTab } from './HistoryTab';

import { useAIShellContext } from '../../AIShellContext';

export const TabsAIShell = () => {
  const { t } = useTranslation('assistant');
  const { tabIndex, setTabIndex } = useAIShellContext();

  return (
    <QBox
      sx={{
        backgroundColor: 'white',
        height: 'calc(100% - 60px)',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <QTabs
        sx={{ borderBottom: '1px solid', borderColor: 'divider', pl: 1 }}
        value={tabIndex}
        onChange={(_event, newValue) => setTabIndex(newValue)}
      >
        <QTab
          icon={<QIcon icon={faMessages} sx={{ fontSize: '16px' }} />}
          label={t('button_labels.chat')}
          sx={{
            width: '50%',
          }}
        />
        <QTab
          icon={<QIcon icon={faClockRotateLeft} sx={{ fontSize: '16px' }} />}
          label={t('button_labels.history')}
          sx={{
            width: '50%',
          }}
        />
      </QTabs>

      <QBox sx={{ height: 'calc(100% - 40px)', position: 'relative' }}>
        {tabIndex === 0 && (
          <QBox sx={{ height: '100%', padding: 0 }}>
            <ChatTab />
          </QBox>
        )}
        {tabIndex === 1 && (
          <QBox sx={{ height: '100%', padding: 0 }}>
            <HistoryTab />
          </QBox>
        )}
      </QBox>
    </QBox>
  );
};
